import Chip from '@mui/joy/Chip';

export default function BasicChip() {
  return (
    <div>
      <Chip>This is a chip</Chip>
    </div>
  );
}
